import envConfig from './env-config';

type SignInProps = {
    track: (
        event: string,
        properties?: Object,
        options?: any,
        callback?: () => void,
    ) => void;
    provider: string;
    callbackUrl: string;
};

const auth = () => {
    const signInWithProvider = async ({
        track,
        provider,
        callbackUrl,
    }: SignInProps) => {
        track('landing_page_provider_button_clicked', { provider });

        // fetch CSRF token
        const csrfRes = await fetch(`${envConfig.AUTH_SERVICE}/csrf`, {
            credentials: 'include',
        });
        const { csrfToken } = await csrfRes.json();

        // build & submit form
        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${
            envConfig.AUTH_SERVICE
        }/signin/${provider.toLowerCase()}?callbackUrl=${encodeURIComponent(
            callbackUrl,
        )}`;

        form.innerHTML = `
            <input type="hidden" name="csrfToken" value="${csrfToken}" />
            `;

        document.body.appendChild(form);
        form.submit();
    };
    const signInWithCredentials = async ({
        name,
        password,
        callbackUrl,
    }: {
        name: string;
        password: string;
        callbackUrl: string;
    }) => {
        const csrfRes = await fetch(`${envConfig.AUTH_SERVICE}/csrf`, {
            credentials: 'include',
        });
        const { csrfToken } = await csrfRes.json();

        const form = document.createElement('form');
        form.method = 'POST';
        form.action = `${
            envConfig.AUTH_SERVICE
        }/callback/credentials?callbackUrl=${encodeURIComponent(callbackUrl)}`;

        form.innerHTML = `
            <input type="hidden" name="csrfToken" value="${csrfToken}" />
            <input type="hidden" name="username" value="${name}" />
            <input type="hidden" name="password" value="${password}" />
        `;

        document.body.appendChild(form);
        form.submit();
    };

    return {
        signInWithProvider,
        signInWithCredentials,
    };
};

export default auth();
